import { render, staticRenderFns } from "./AppSynopsis.vue?vue&type=template&id=514cd9d4&scoped=true&"
import script from "./AppSynopsis.vue?vue&type=script&lang=js&"
export * from "./AppSynopsis.vue?vue&type=script&lang=js&"
import style0 from "./AppSynopsis.vue?vue&type=style&index=0&id=514cd9d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514cd9d4",
  null
  
)

export default component.exports